import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=eb3a6428"
import script from "./Owners.js?vue&type=script&lang=js&external"
export * from "./Owners.js?vue&type=script&lang=js&external"
import style0 from "./Owners.vue?vue&type=style&index=0&id=eb3a6428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports